import { createSlice } from '@reduxjs/toolkit';

type State = { isDev: boolean }

const initialState: State = { isDev: false };

const devStateSlice = createSlice({
  name: 'devState',
  initialState,
  reducers: {
    updateDevState(state: State, action: { payload: boolean }) {
      state.isDev = action.payload;
    },
  },
});

export const { updateDevState } = devStateSlice.actions;

export default devStateSlice.reducer;
